import { fetcher } from "../fetcher";

type GetSchedulesParams = {
  client_project_id: number;
  order_by?:
    | "id"
    | "name"
    | "completion_date"
    | "status"
    | "created_at"
    | "updated_at";
  order_direction?: "asc" | "desc";
};

export const schedulesService = {
  getSchedules: async (params?: GetSchedulesParams) => {
    const paramsWithDefaults = {
      ...params,
      order_by: params?.order_by ?? ("completion_date" as const),
      order_direction: params?.order_direction ?? ("asc" as const),
    };

    return await fetcher(`/schedules/all`, {
      method: "GET",
      params: paramsWithDefaults,
      schema: schedulesSchema,
    });
  },
};
